import { ActionIcon, Flex, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconEye } from '@tabler/icons-react';

import { TariffCard, type VacancyTariff } from '@entities/vacancy';

import { TariffHistoryDrawer } from './TariffHistoryDrawer';

export interface TariffWidgetProps {
  vacancyId: number;
  tariff: VacancyTariff;
}

export const TariffWidget = ({ vacancyId, tariff }: TariffWidgetProps) => {
  const [historyOpened, { open: openHistory, close: closeHistory }] =
    useDisclosure(false);

  return (
    <>
      <Flex
        direction='column'
        gap={24}
        p={24}
        maw={418}
        w='100%'
        bg='primary.0'
        style={{ borderRadius: 16, overflow: 'hidden' }}
      >
        <Flex
          justify='space-between'
          align='center'
          w='100%'
          wrap='nowrap'
          gap='md'
        >
          <Text c='primary.7' size='lg' fw={600}>
            Тариф
          </Text>
          <Flex gap={16} align='center'>
            <ActionIcon
              size={32}
              variant='transparent'
              onClick={openHistory}
              aria-label='История изменений тарифа'
            >
              <IconEye
                size={24}
                stroke={1.5}
                color='var(--mantine-color-primary-7)'
              />
            </ActionIcon>
          </Flex>
        </Flex>

        <TariffCard tariff={tariff} />
      </Flex>

      <TariffHistoryDrawer
        opened={historyOpened}
        close={closeHistory}
        vacancyId={vacancyId}
      />
    </>
  );
};
